import { somenteDigitos } from "./helpers";

const VAZIO = "—";

const texto = (valor) => `${valor === null || valor === undefined ? "" : valor}`.trim();

const juntar = (partes, separador) => partes.map(texto).filter(Boolean).join(separador);

/**
 * Linhas exibidas lado a lado na efetivação: mesma ordem e mesmo formato para o responsável
 * atual e para o pagador. `chave` é o valor normalizado usado só para comparar os dois lados.
 *
 * @param {Object} pessoa nome, cpf, email, logradouro, numero, bairro, cidade, uf, cep
 * @param {Function} siglaDaUf converte o que veio em `uf` (nome por extenso ou sigla) em sigla
 */
export function linhasDoResponsavel(pessoa, siglaDaUf) {
  const cpf = somenteDigitos(pessoa.cpf);
  const cep = somenteDigitos(pessoa.cep);
  const uf = texto(pessoa.uf);
  const linhas = [
    {
      rotulo: "Nome",
      valor: texto(pessoa.nome),
      chave: texto(pessoa.nome).toLowerCase(),
    },
    {
      rotulo: "CPF",
      valor: cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"),
      chave: cpf,
    },
    {
      rotulo: "E-mail",
      valor: texto(pessoa.email),
      chave: texto(pessoa.email).toLowerCase(),
    },
    {
      rotulo: "Endereço",
      valor: juntar([pessoa.logradouro, pessoa.numero], ", "),
      chave: juntar([pessoa.logradouro, pessoa.numero], ", ").toLowerCase(),
    },
    {
      rotulo: "Bairro",
      valor: texto(pessoa.bairro),
      chave: texto(pessoa.bairro).toLowerCase(),
    },
    {
      rotulo: "Cidade/UF",
      valor: juntar([pessoa.cidade, uf], "/"),
      chave: `${texto(pessoa.cidade).toLowerCase()}/${siglaDaUf(uf)}`,
    },
    {
      rotulo: "CEP",
      valor: cep.replace(/(\d{5})(\d{3})/, "$1-$2"),
      chave: cep,
    },
  ];
  return linhas.map((linha) => ({ ...linha, valor: linha.valor || VAZIO }));
}

/** Rótulos das linhas em que os dois lados diferem. */
export function rotulosDiferentes(linhasA, linhasB) {
  return linhasA
    .filter((linha, indice) => linha.chave !== linhasB[indice].chave)
    .map((linha) => linha.rotulo);
}
